import React, { useState } from 'react';
import { Table, Input, DatePicker } from 'antd';
import Pagination from './Pagination';
import { Select, Button } from 'antd';
import { CSVLink } from 'react-csv';
import { useLocation } from 'react-router-dom';


const { RangePicker } = DatePicker;
const { Search } = Input;

const AllTransactionTable = ({ data, handleSearch, handleDateChange, setSelectedLevel, selectedLevel, prepareDataForCSV, onSearch, columns, dataSource, page, onLevelChange, totalPages, size, setPage, setSize }) => {

    const location = useLocation();

    const handleChange = (value) => {
        setSelectedLevel(value);
        onLevelChange(value);
    };

    const Rank = [
        // "Intern",
        "Team Leader",
        "Team Manager",
        "Senior Manager",
        "Director",
        "Senior Director",
        "Global Director",
        "President",
        "Senior President",
        "Global President",
        "Crown President"
    ]

    const WalletList = [
        "BEP.20",
        "TRC.20",
    ]

    const filteredDataSource = (location.pathname === '/rank&rewardtransaction' || location.pathname === '/rank&rewardstatus')
        ? (selectedLevel ? dataSource.filter(item => item.Rank === selectedLevel) : dataSource)
        : (location.pathname === '/walletlisttrans' || location.pathname === '/withdrawaltransaction')
            ? (selectedLevel ? dataSource.filter(item => item.Network === selectedLevel) : dataSource)
            : dataSource;
    const onChange = (pagination) => {
        setPage(pagination.current);
        setSize(pagination.size);
    };

    const onPageChange = (page) => {
        setPage(page);
    };

    const handlePageSizeChange = (size) => {
        setSize(size);
    };

    const handleInputChange = (e) => {
        const noSpaceValue = e.target.value.replace(/\s+/g, '').toLowerCase();
        handleSearch(noSpaceValue);
    };

    const handleKeyDown = (e) => {
        if (e.key === ' ') {
            e.preventDefault();
        }
    };

    const isSubsofferRoute = location.pathname === '/subsoffer';

    return (
        <>
            <div className='md:flex justify-between items-center gap-4'>
                {/* <div>
                    <Search placeholder='Username Search...' onSearch={(value) => handleSearch(value.trim().toLowerCase())}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                    />
                </div> */}


                <div className='my-2 md:my-0'>
                    {(location.pathname == '/rank&rewardtransaction' || location.pathname == "/rank&rewardstatus") && (
                        <Select
                            defaultValue="Select Rank"
                            style={{
                                width: 220,
                            }}
                            onChange={handleChange}
                            value={selectedLevel}
                        >
                            <Select.Option key="Select Rank" value={null}>
                                Select Rank
                            </Select.Option>
                            {Rank.map(level => (
                                <Select.Option key={level} value={level}>
                                    {level}
                                </Select.Option>
                            ))}
                        </Select>
                    )}
                    {(location.pathname == '/walletlisttrans' || location.pathname == '/withdrawaltransaction') && (
                        <Select
                            defaultValue="Select Network"
                            style={{
                                width: 220,
                            }}
                            onChange={handleChange}
                            value={selectedLevel}
                        >
                            <Select.Option key="Select Network" value={null}>
                                Select Network
                            </Select.Option>
                            {WalletList.map(level => (
                                <Select.Option key={level} value={level}>
                                    {level}
                                </Select.Option>
                            ))}
                        </Select>
                    )}



                </div>
{/* 
                <div>
                    {(location.pathname !== "/matchinincometransaction" && location.pathname !== "/subsoffer" && location.pathname !== "/kyclist" && location.pathname !== "/rank&rewardtransaction") && (
                        < RangePicker className='my-2 md:my-0' onChange={handleDateChange} format={'DD-MM-YYYY'} />
                    )}
                </div> */}

                <div>
                    <Button type="colorSecondaryDark" className="ml-3 border-2 border-colorSecondaryDark my-2 md:my-0">
                        <CSVLink
                            data={prepareDataForCSV()}
                            filename={'user_data.csv'}
                            className="text-white"
                        >
                            Download CSV
                        </CSVLink>
                    </Button>
                </div>
            </div>
            <Table className='my-3' columns={columns} dataSource={filteredDataSource} onChange={onChange} pagination={isSubsofferRoute} />
            {!isSubsofferRoute && (
                <Pagination
                    totalPages={totalPages}
                    currentPage={page}
                    pageSize={size}
                    onPageChange={onPageChange}
                    onPageSizeChange={handlePageSizeChange}
                />
            )}
        </>
    );
};

export default AllTransactionTable;
